import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionLaughingIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" fill="#FFEACC" />
    <path
      fill="#5B5B5B"
      d="M16.033 28c5.058 0 9.317-3.352 10.582-7.843.266-.939-.533-1.81-1.464-1.81H6.849c-.931 0-1.73.871-1.464 1.81 1.265 4.49 5.524 7.842 10.648 7.842ZM7.848 6.75c-.533-.267-1.132.135-1.132.738 0 .134 0 .335.133.47l2.396 2.881-2.396 2.95c-.133.134-.133.335-.133.47 0 .602.6 1.005 1.132.736l5.99-3.217a1.02 1.02 0 0 0 0-1.81l-5.99-3.217Zm17.502.738c0-.603-.665-1.005-1.198-.737l-5.99 3.217a1.02 1.02 0 0 0 0 1.81l5.99 3.217c.533.269 1.198-.134 1.198-.737a.727.727 0 0 0-.2-.47l-2.395-2.949 2.396-2.882a.727.727 0 0 0 .2-.469Z"
    />
  </Icon>
);

export default memo(ReactionLaughingIcon);
